// Unified API wrapper with Bearer token authentication

import { getToken } from './auth';
import { API_BASE_URL } from '../config';

export const API_URL = API_BASE_URL;

export const apiFetch = async (url: string, options: any = {}) => {
  const token = getToken();
  const path = new URL(url, 'http://localhost').pathname;
  const isPublicAuthRequest = path === '/api/auth/login' || path === '/api/auth/register';
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  if (token && !isPublicAuthRequest) headers.set('Authorization', `Bearer ${token}`);

  return fetch(url, {
    ...options,
    headers,
  });
};
